<template>
  <section class="uk-text-left container uk-margin-remove ">
    <loading
      :active="isLoading"
      :is-full-page="true"
    />
    <section class="section-titles">
      <h3 class="title">
        Características del Trayecto
      </h3>
      <p class="subtitle helper uk-margin-remove">
        INSTRUCCIONES: Favor seleccionar el modo de transporte del tramo internacional (Marítimo o Aéreo),
        la dirección del trayecto (Importación o Exportación), y el tipo de carga (Refrigerada o Seca).
      </p>
    </section>
    <div class="main">
      <form>
        <div
          class="uk-column-1-2 uk-margin uk-form-label uk-flex"
          @mouseover="setMessageInformation('Especifique la fecha de salida')"
          @mouseleave="setMessageInformation()"
        >
          <label
            class="filter"
            for="dispatchDate"
          >Fecha de Despacho
            <input
              id="dispatchDate"
              v-model="pathCharacteristics.dispatchDate"
              class="uk-input filterInput"
              type="date"
              data-uk-datepicker="{format:'DD.MM.YYYY'}"
              :min="newDate"
            >
          </label>
        </div>

        <div>
          <h5 class="uk-text-bolder destiny-transport">
            Origen
          </h5>

          <div class="uk-flex uk-flex-between uk-flex-wrap">
            <div
              class="item filter"
              @mouseover="setMessageInformation('Especifique el País de Origen')"
              @mouseleave="setMessageInformation()"
            >
              <label
                class="uk-form-label"
                for="originCountryId"
              >País</label>
              <div class="uk-form-controls ">
                <select
                  id="originCountryId"
                  v-model="pathCharacteristics.availablePath.originCountryId"
                  class="uk-select filterInput"
                >
                  <option
                    v-for="originCountry in originCountries"
                    :key="originCountry.id"
                    :value="originCountry.id"
                  >
                    {{ originCountry.description }}
                  </option>
                </select>
              </div>
            </div>

            <div
              v-if="incoterm.originCity"
              class="item filter"
              @mouseover="setMessageInformation('Especifique la Ciudad de Origen')"
              @mouseleave="setMessageInformation()"
            >
              <label
                class="uk-form-label"
                for="originCity"
              >Ciudad</label>
              <div class="uk-form-controls">
                <select
                  id="originCity"
                  v-model="pathCharacteristics.availablePath.originCityId"
                  :disabled="isOriginCountryVisible"
                  class="uk-select filterInput"
                >
                  <option
                    v-for="originCity in originCities"
                    :key="originCity.id"
                    :value="originCity.id"
                  >
                    {{ originCity.description }}
                  </option>
                </select>
              </div>
            </div>

            <div
              v-if="incoterm.originTerminal"
              class="item filter"
              @mouseover="setMessageInformation('Especifique la Terminal de Origen')"
              @mouseleave="setMessageInformation()"
            >
              <label
                class="uk-form-label"
                for="originTerminal"
              >Terminal</label>
              <div class="uk-form-controls">
                <select
                  id="originTerminal"
                  v-model="pathCharacteristics.availablePath.originTerminalId"
                  :disabled="isOriginCountryVisible"
                  class="uk-select filterInput"
                >
                  <option
                    v-for="originTerminal in originTerminals"
                    :key="originTerminal.id"
                    :value="originTerminal.id"
                  >
                    {{ originTerminal.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <h5 class="uk-text-bolder destiny-transport">
            Destino
          </h5>

          <div class="uk-flex uk-flex-between uk-flex-wrap">
            <div
              class="item filter"
              @mouseover="setMessageInformation('Especifique el País de Destino')"
              @mouseleave="setMessageInformation()"
            >
              <label
                class="uk-form-label"
                for="destinationCountryId"
              >País</label>
              <div class="uk-form-controls">
                <select
                  id="destinationCountryId"
                  v-model="pathCharacteristics.availablePath.destinationCountryId"
                  class="uk-select filterInput"
                  :disabled="countryDisabled"
                >
                  <option
                    v-for="destinationCountry in destinationCountries"
                    :key="destinationCountry.id"
                    :value="destinationCountry.id"
                  >
                    {{ destinationCountry.description }}
                  </option>
                </select>
              </div>
            </div>

            <div
              v-if="incoterm.destinationTerminal"
              class="item filter"
              @mouseover="setMessageInformation('Especifique la Terminal de Destino')"
              @mouseleave="setMessageInformation()"
            >
              <label
                class="uk-form-label"
                for="detinationTerminals"
              >Terminal</label>
              <div class="uk-form-controls">
                <select
                  id="detinationTerminals"
                  v-model="pathCharacteristics.availablePath.destinationTerminalId"
                  class="uk-select filterInput"
                  :disabled="isDestinationCountryVisible"
                  @change="changeDestinationTerminal"
                >
                  <option
                    v-for="detinationTerminal in detinationTerminals"
                    :key="detinationTerminal.id"
                    :value="detinationTerminal.id"
                  >
                    {{ detinationTerminal.description }}
                  </option>
                </select>
              </div>
            </div>

            <div
              v-if="incoterm.destinationCity"
              class="item filter"
              @mouseover="setMessageInformation('Especifique la Ciudad de Destino')"
              @mouseleave="setMessageInformation()"
            >
              <label
                class="uk-form-label"
                for="destinationCity"
              >Ciudad</label>
              <div class="uk-form-controls">
                <select
                  id="destinationCity"
                  v-model="pathCharacteristics.availablePath.destinationCityId"
                  class="uk-select filterInput"
                  :disabled="isDestinationCountryVisible"
                  @change="changeDestinationTerminal"
                >
                  <option
                    v-for="destinationCity in destinationCities"
                    :key="destinationCity.id"
                    :value="destinationCity.id"
                  >
                    {{ destinationCity.description }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            v-if="isDate"
            class="uk-alert-danger"
            uk-alert
          >
            <a
              class="uk-alert-close"
              uk-close
            />
            <p>Seleccione la fecha.</p>
          </div>

          <h5 class="uk-text-bold result-distance">
            Distancia Estimadas
          </h5>

          <div class="uk-margin">
            <div class="uk-margin">
              <div
                v-if="isContentBlocked"
                class="blocked-content"
              />
              <div
                class="uk-flex InputColumn"
                @mouseover="setMessageInformation('Distancia en el origen')"
                @mouseleave="setMessageInformation()"
              >
                <input
                  v-model="terrestrialDistanceOriginRound"
                  type="number"
                  class="uk-input uk-width-1-5 uk-margin-right filterDistance filterInput"
                  disabled
                  min="0"
                  max="9999999"
                >
                <div class="uk-flex uk-flex-middle weight">
                  <label class="labelMargin"> ({{ distanceTraveled?.terrestrialDistanceOrigin?.abbreviation }})</label>
                  <div class="div-margin-left">
                    <font-awesome-icon
                      class="icon-adress labelMargin"
                      icon="caret-down"
                      style="font-size: 17px; cursor: pointer;"
                    />
                    <div
                      id="originDistan1"
                      style="width: 20%;"
                      uk-dropdown="mode: click"
                    >
                      <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                        <li
                          v-for="value in measurementUnits"
                          :key="value"
                          :value="value"
                          class="uk-active"
                          @click="distanceTraveled.terrestrialDistanceOrigin = value; closeHide('originDistan1')"
                        >
                          <span style="cursor: pointer">{{ value.description }} </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <label>Terrestre en el Origen</label>
                </div>
              </div>

              <div
                class="uk-flex uk-margin InputColumn"
                @mouseover="setMessageInformation('Distancia Marítimo o Aérea')"
                @mouseleave="setMessageInformation()"
              >
                <input
                  v-model="distanceMaritimeAereoRound"
                  type="number"
                  class="uk-input uk-width-1-5 uk-margin-right filterDistance filterInput"
                  disabled
                  min="0"
                  max="9999999"
                >
                <div class="uk-flex uk-flex-middle weight">
                  <label class="labelMargin"> ({{ distanceTraveled?.distanceMaritimeAereo?.abbreviation }})</label>
                  <div class="div-margin-left">
                    <font-awesome-icon
                      class="icon-adress labelMargin"
                      icon="caret-down"
                      style="font-size: 17px; cursor: pointer;"
                    />
                    <div
                      id="distanceMA"
                      style="width: 20%;"
                      uk-dropdown="mode: click"
                      disabled
                    >
                      <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                        <li
                          v-for="value in measurementUnits"
                          :key="value"
                          :value="value"
                          class="uk-active"
                          @click="distanceTraveled.distanceMaritimeAereo = value; closeHide('distanceMA')"
                        >
                          <span style="cursor: pointer">{{ value.description }} </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <label>Transporte Marítimo/Aéreo</label>
                </div>
              </div>

              <div
                class="uk-flex InputColumn"
                @mouseover="setMessageInformation('Distancia en el destino')"
                @mouseleave="setMessageInformation()"
              >
                <input
                  v-model="destinationDistanceRound"
                  type="number"
                  class="uk-input uk-width-1-5 uk-margin-right filterDistance filterInput"
                  disabled
                  min="0"
                  max="9999999"
                >
                <div class="uk-flex uk-flex-middle weight">
                  <label class="labelMargin"> ({{ distanceTraveled?.destinationDistance?.abbreviation }})</label>
                  <div class="div-margin-left">
                    <font-awesome-icon
                      class="icon-adress labelMargin"
                      icon="caret-down"
                      style="font-size: 17px; cursor: pointer;"
                    />
                    <div
                      id="destinationDistance"
                      style="width: 26.5%;"
                      uk-dropdown="mode: click"
                    >
                      <ul class="uk-nav uk-dropdown-nav uk-width-medium">
                        <li
                          v-for="value in measurementUnits"
                          :key="value"
                          :value="value"
                          class="uk-active"
                          @click="distanceTraveled.destinationDistance = value; closeHide('destinationDistance')"
                        >
                          <span style="cursor: pointer">{{ value.description }} </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <label>Terrestre en el Destino</label>
                </div>
              </div>
              <article
                class="uk-flex uk-margin InputColumn"
                @mouseover="setMessageInformation('Cantidad de horas de viaje')"
                @mouseleave="setMessageInformation()"
              >
                <input
                  id="quantity"
                  v-model="distanceTraveled.distanceTotalHours"
                  name="quantity"
                  min="0"
                  max="9999999"
                  class="uk-input uk-width-1-4 uk-margin-right filterDistance filterInput"
                  type="number"
                  disabled
                  placeholder="0"
                >
                <div class="uk-width-2-4 uk-flex uk-flex-middle weight">
                  <labe> No. Total de Horas</labe>
                </div>
              </article>
            </div>
          </div>
        </div>
      </form>
    </div>
    <wizard-button :data="infoPathCharacteristics" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      newDate: null,
      isValueDintance: null,
      isChangeDropdown: true,
      isLoading: false,
      resultDistance: {},
      pathCharacteristics: {
        dispatchDate: null,
        totalCost: 0,
        availablePath: {
          originCountryId: null,
          destinationCountryId: null,
          originTerminalId: null,
          originCityId: null,
          destinationTerminalId: null,
          destinationCityId: null,
          transportMode: null
        }
      },
      distanceTraveled: {
        terrestrialDistanceOrigin: null,
        originDistanceNumber: null,
        distanceMaritimeAereo: null,
        maritimeAereoDistanceNumber: null,
        destinationDistance: null,
        destinationDistanceNumber: null,
        distanceTotalHours: null
      },
      estimatedDistance: null,
      totalDays: null,

      originCountries: [],
      countryTerminal: [],
      originCities: [],
      destinationCities: [],
      destinationShipments: [],
      originTerminals: [],
      detinationTerminals: [],
      measurementUnits: [],
      distanceDictionary: new Map(),

      informationMsg: {
        image: null,
        message: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'storePathCharacteristics',
      'transportMode',
      'incoterm',
      'storeShippingFeatures'
    ]),
    countryDisabled: function () {
      if (this.pathCharacteristics.availablePath.originCityId || this.pathCharacteristics.availablePath.originTerminalId) {
        return false
      }
      return true
    },
    isDestinationCountryVisible: function () {
      if (this.pathCharacteristics.availablePath.destinationCountryId) {
        return false
      }
      return true
    },
    isOriginCountryVisible: function () {
      if (this.pathCharacteristics.availablePath.originCountryId) {
        return false
      }
      return true
    },
    destinationCountries: function () {
      if (this.originCountries && this.originCountries.length > 0) {
        return this.originCountries.filter(el => el.id !== this.pathCharacteristics.availablePath.originCountryId)
      } else return []
    },
    isContentBlocked () {
      return !(this.pathCharacteristics.availablePath.destinationCityId && this.pathCharacteristics.dispatchDate)
    },
    isDate () {
      return (this.incoterm.originCity === false || this.pathCharacteristics.availablePath.originCityId !== null) &&
             (this.incoterm.originTerminal === false || this.pathCharacteristics.availablePath.originTerminalId !== null) &&
             (this.incoterm.destinationTerminal === false || this.pathCharacteristics.availablePath.destinationTerminalId !== null) &&
             (this.incoterm.destinationCity === false || this.pathCharacteristics.availablePath.destinationCityId !== null) &&
             this.pathCharacteristics.dispatchDate === null
    },
    terrestrialDistanceOriginRound () {
      if (this.distanceTraveled.originDistanceNumber) {
        return parseFloat(this.distanceTraveled.originDistanceNumber.toFixed(2))
      }
      return 0
    },
    distanceMaritimeAereoRound () {
      if (this.distanceTraveled.maritimeAereoDistanceNumber) {
        return parseFloat(this.distanceTraveled.maritimeAereoDistanceNumber.toFixed(2))
      }
      return 0
    },
    destinationDistanceRound () {
      if (this.distanceTraveled.destinationDistanceNumber) {
        return parseFloat(this.distanceTraveled.destinationDistanceNumber.toFixed(2))
      }
      return 0
    },
    infoPathCharacteristics () {
      return {
        ...this.pathCharacteristics.availablePath,
        ...this.pathCharacteristics
      }
    }
  },
  watch: {
    resultDistance: {
      handler: function (newVal, oldVal) {
        this.setDistanceTraveled()
      },
      deep: true
    },

    'pathCharacteristics.availablePath.originCountryId': async function (newVal, oldVal) {
      if (this.isChangeDropdown) {
        this.changeOrigin()
        await this.changeOriginCountryId()
      }
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    },

    'pathCharacteristics.availablePath.destinationCountryId': async function (newVal, oldVal) {
      if (this.isChangeDropdown) {
        this.changeOriginTerminal()
        await this.changeDestinationCountryId()
      }
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    },
    'pathCharacteristics.availablePath.originTerminalId': async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    },
    'pathCharacteristics.availablePath.originCityId': async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    },
    'pathCharacteristics.availablePath.destinationTerminalId': async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    },
    'pathCharacteristics.availablePath.destinationCityId': async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    },
    pathCharacteristics: {
      handler: async function (newVal) {
        try {
          this.$store.commit('setPathCharacteristics', newVal)
          if (newVal.dispatchDate && newVal.availablePath.originCountryId && newVal.availablePath.destinationCountryId && newVal.availablePath.originCityId && newVal.availablePath.destinationCityId && newVal.availablePath.originTerminalId && newVal.availablePath.destinationTerminalId) {
            this.isLoading = true
            this.resultDistance = await this.$services.availablePathService.getDistance(this.pathCharacteristics.availablePath, this.incoterm.id)
            this.setDistanceTraveled()
            this.isValueDintance = false
          } else {
            this.resultDistance = {}
          }
        } catch (error) {
          this.isValueDintance = true
          this.clearDestinationRoutes()
          console.log(error)
          this.$toast.warning('No existe una ruta disponible entre estos puertos', {
            position: 'top',
            duration: 4000
          })
        }
        this.isLoading = false
      },
      deep: true

    },
    'distanceTraveled.terrestrialDistanceOrigin': function (newVal, oldVal) {
      if (oldVal != null && newVal != null) {
        this.distanceTraveled.originDistanceNumber = this.convert(this.distanceTraveled.originDistanceNumber, this.distanceDictionary?.get(oldVal.abbreviation), this.distanceDictionary?.get(newVal.abbreviation))
      }
    },
    'distanceTraveled.distanceMaritimeAereo': function (newVal, oldVal) {
      if (oldVal != null && newVal != null) {
        this.distanceTraveled.maritimeAereoDistanceNumber = this.convert(this.distanceTraveled.maritimeAereoDistanceNumber, this.distanceDictionary?.get(oldVal.abbreviation), this.distanceDictionary?.get(newVal.abbreviation))
      }
    },
    'distanceTraveled.destinationDistance': function (newVal, oldVal) {
      if (oldVal != null && newVal != null) {
        this.distanceTraveled.destinationDistanceNumber = this.convert(this.distanceTraveled.destinationDistanceNumber, this.distanceDictionary?.get(oldVal.abbreviation), this.distanceDictionary?.get(newVal.abbreviation))
      }
    },
    'pathCharacteristics.dispatchDate': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultValues2()
      }
    }
  },
  beforeMount () {
    this.distanceDictionary.set('mi', 0.000621371) // milla
    this.distanceDictionary.set('km', 0.001) // kilometro
    this.distanceDictionary.set('m', 1) // metro
    this.distanceDictionary.set('cm', 100) // centimetro
    this.distanceDictionary.set('mm', 1000) // milimetro
  },
  async mounted () {
    this.newDate = moment(new Date()).format('YYYY-MM-DD')
    await this.setStore()
  },

  methods: {
    async setStore () {
      // deshabilito los watch colocando la propiedad isChangeDropdown como falso
      this.isChangeDropdown = false
      this.pathCharacteristics = { ...this.storePathCharacteristics }
      await this.initOrigin()
      await this.changeOriginCountryId()
      await this.changeDestinationCountryId()
      await this.setDistanceTraveled()
      this.isChangeDropdown = true
      this.setDefaultValues()
    },
    async initOrigin () {
      try {
        this.isLoading = true
        this.originCountries = await this.$services.countryService.getCountries()
        this.measurementUnits = await this.$services.measurementUnitService.getAll()
        this.isLoading = false
        this.countryDisabled = true
      } catch (error) {
        console.log(error)
        this.$toast.warning('No existe una ruta disponible entre estos puertos', {
          position: 'top',
          duration: 4000
        })
        this.isLoading = false
      }
    },
    async  changeOriginCountryId () {
      try {
        if (!this.pathCharacteristics.availablePath.originCountryId) return
        this.isLoading = true
        this.originCities = await this.$services.countryService.getCities(this.pathCharacteristics.availablePath.originCountryId)
        this.originTerminals = await this.$services.countryService.getTerminals(this.pathCharacteristics.availablePath.originCountryId, this.transportMode)
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.$toast.warning('No existe una ruta disponible entre estos puertos', {
          position: 'top',
          duration: 4000
        })
      }
    },
    async changeDestinationCountryId () {
      try {
        if (!this.pathCharacteristics?.availablePath?.destinationCountryId) return
        this.isLoading = true
        this.destinationCities = await this.$services.countryService.getCities(this.pathCharacteristics.availablePath.destinationCountryId)
        this.detinationTerminals = await this.$services.countryService.getTerminals(this.pathCharacteristics.availablePath.destinationCountryId, this.transportMode)
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.$toast.warning('No existe una ruta disponible entre estos puertos', {
          position: 'top',
          duration: 4000
        })
      }
    },
    setMessageInformation (message, image) {
      this.informationMsg.image = image
      this.informationMsg.message = message

      this.$store.commit('setMessageInformation', this.informationMsg)
    },
    changeOrigin () {
      this.pathCharacteristics.availablePath.destinationCountryId = null
      this.pathCharacteristics.availablePath.originCityId = null
      this.pathCharacteristics.availablePath.destinationCityId = null
      this.pathCharacteristics.availablePath.originTerminalId = null
      this.pathCharacteristics.availablePath.destinationTerminalId = null
      this.destinationShipments = []
      this.originCities = []
      this.destinationCities = []
      this.originTerminals = []
      this.detinationTerminals = []
      this.estimatedDistance = null
      this.totalDays = null
    },
    changeOriginTerminal () {
      this.pathCharacteristics.availablePath.destinationTerminalId = null
      this.estimatedDistance = null
      this.totalDays = null
      this.detinationTerminals = []
    },
    changeDestinationTerminal () {
      this.estimatedDistance = null
      this.totalDays = null
    },
    async setDistanceTraveled () {
      if (this.resultDistance?.landDistanceAtOrigin?.distance) {
        this.distanceTraveled.originDistanceNumber = await this.resultDistance?.landDistanceAtOrigin?.distance
      }
      if (this.resultDistance?.internationalDistance?.distance) {
        this.distanceTraveled.maritimeAereoDistanceNumber = this.resultDistance?.internationalDistance?.distance
      }
      if (this.resultDistance?.landDistanceAtDestination?.distance) {
        this.distanceTraveled.destinationDistanceNumber = this.resultDistance?.landDistanceAtDestination?.distance
      }
      if (this.resultDistance?.totalHours) {
        this.distanceTraveled.distanceTotalHours = this.resultDistance?.totalHours
      }
    },
    clearDestinationRoutes () {
      this.distanceTraveled.terrestrialDistanceOrigin = null
      this.distanceTraveled.originDistanceNumber = null
      this.distanceTraveled.distanceMaritimeAereo = null
      this.distanceTraveled.maritimeAereoDistanceNumber = null
      this.distanceTraveled.destinationDistance = null
      this.distanceTraveled.destinationDistanceNumber = null
      this.distanceTraveled.distanceTotalHours = null
    },
    openShow (id) {
      UIkit.dropdown(`#${id}`).show() // eslint-disable-line
    },
    closeHide (id) {
      UIkit.dropdown(`#${id}`).hide(0)  // eslint-disable-line
    },
    setDefaultValues () {
      if (!this.distanceTraveled.terrestrialDistanceOrigin) {
        this.distanceTraveled.terrestrialDistanceOrigin = this.measurementUnits.find(x => x.id === 1)
      }

      if (!this.distanceTraveled.distanceMaritimeAereo) {
        this.distanceTraveled.distanceMaritimeAereo = this.measurementUnits.find(x => x.id === 1)
      }

      if (!this.distanceTraveled.destinationDistance) {
        this.distanceTraveled.destinationDistance = this.measurementUnits.find(x => x.id === 1)
      }
    },
    convert (num, oldVal, newVal) {
      if (num) {
        num = num / oldVal * newVal
        num = parseFloat(num.toFixed(5))
        return num
      }
    },
    setDefaultValues2 () {
      this.distanceTraveled.terrestrialDistanceOrigin = this.measurementUnits.find(x => x.id === 1)

      this.distanceTraveled.distanceMaritimeAereo = this.measurementUnits.find(x => x.id === 1)

      this.distanceTraveled.destinationDistance = this.measurementUnits.find(x => x.id === 1)
    }
  }
}
</script>

<style scoped>
.container{
  padding: 15px 40px;
}
p {
  margin: 10px;
}
.labeltext {
  font-weight:600;
  color: #333 !important;
}
.uk-padding{
  padding-top: 5px ;
}
.main{
  margin-top: 30px;
}

.item{
  min-width: 150px;
  width: 30%;
  margin: 15px 10px;;
}
.title{

  font-weight: 600;
  margin-bottom: 10px;
}
 .section-titles{
  width: 80%;
}
.subtitle{
  margin: 0px 0px 30px 0px;
}
.helper{
  color:rgb(119 118 118 / 58%) !important
}

.destiny-transport{
  font-size: 14px;
}
.result-distance{
  font-size: 14px;
}
.blocked-content {
  background: white;
  opacity: .9;
  width: 100%;
  height: 240px;
  position: absolute;
}
.titleTotal {
  margin: 10px 0;
}
.labelCenterInput {
  display: flex;
  align-items: center;
}
.labelMargin {
  margin: 0 5px 0 0;
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    margin-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
  .result-distance{
    margin: 10px 0px;
    font-size: 13px;
  }
.container{
  padding: 10px 20px;
}
.filter{
  min-width: 200px;
  flex-grow: 1;
  width: 40%;
  margin: 0 10px 0 5px;
}

.filterDistance{
  min-width: 265px;
  max-width: 270px;
  flex-grow: 1;
  width: 40%;
  margin: 0 10px 0 5px;
}
.filterInput {
  padding-left: 3px ;

  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
  /* min-width: 110px; */
  width: 30%;
  margin: 5px 15px 5px 0px;
}
section{
  padding: 0px 10px;
}

.destiny-transport{
  font-size: 12px;
}
}

@media screen and (max-width: 430px){
  .section-titles {
  margin: 0 5px 0 10px;
}
.main {
  margin: 0 5px 0 10px;
}
.weight {
  margin: 10px 0 0 10px;
}
.InputColumn {
display: flex;
flex-direction: column;
}

.filterDistance{
  min-width: 200px;
  max-width: 100%;
  width: 95%;
}

.blocked-content {
  background: white;
  opacity: .9;
  width: 100%;
  height: 330px;
  position: absolute;
}

}

</style>
